Vendd.Scripts.load(function () {

    //todo: review the code below 
    $('.x-control.x-requestorderchange-form[data-control="form"][data-ajax="true"]').each(function (i, form) {

        form.onSuccess = function (request, response) {

            var redirectUrl = $(this).data('redirect');

            if (redirectUrl != undefined && redirectUrl != '') {
                this.success = true;
                this.showLoader();

                document.location = redirectUrl;
            }

        };

    });

});

